import { createContext, useContext } from 'react';

import type { SessionUser } from '../shared/api-client.js';

export interface SessionContextValue {
  readonly session: SessionUser;
}

export const SessionContext = createContext<SessionContextValue | undefined>(undefined);

export function useSession(): SessionUser {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSession must be used inside SessionBoundary');
  }
  return context.session;
}
